export var MAX_LINKS_TO_SHOW = 4;
export var SEE_LESS = 'See less';
export var SEE_MORE = 'See more';